import queryString from 'query-string';

const isPublicUrl = () => {
  const parsedParams = queryString.parse(window.location.search);

  const { p: isPublic } = parsedParams;

  return Boolean(isPublic);
};

export default isPublicUrl;